const ROLES = {
  superAdmin: 'tivi-root-admin',
  eventAdmin: 'tivi-event-admin',
  pollWorker: 'tivi-pollworker',
  auditor: 'auditor',
  eventAdminDeveloper: 'tivi-developer',
  voterAdminDeveloper: 'voter-admin-developer',
  contactInfo: 'tivi-contactinfo',
}

export const DefaultAdminRolesRequiredPerAction = {
  strikeOffEnabled: [ROLES.superAdmin],
  adminUsers: {
    add: [ROLES.superAdmin],
    delete: [ROLES.superAdmin],
    authActions: [ROLES.superAdmin, ROLES.contactInfo],
  },
}
